import { render } from "./HeroiconsSolidBeaker.vue?vue&type=template&id=19aeba84"
const script = {}

import exportComponent from "/home/malezha/zfort/digitalfax/nova/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"HeroiconsSolidBeaker.vue"]])

export default __exports__